import { lt } from '@mews/framework';
import { Banner } from '@optimus-web/core';
import { RateGroupLimitReached, RateGroupLimitReachedProps } from './RateGroupLimitReached';

export interface FormChecksProps extends RateGroupLimitReachedProps {
    children: React.ReactNode;
    hasAllResourcesLimitReached: boolean;
    hasAvailableResources: boolean;
    hasRateGroupLimitReached: boolean;
    isAllResourcesCategory: boolean;
}

export const FormChecks = ({
    children,
    hasAllResourcesLimitReached,
    hasAvailableResources,
    hasRateGroupLimitReached,
    isAllResourcesCategory,
    ...other
}: FormChecksProps) => {
    if (!hasAvailableResources) {
        return <Banner primaryText={lt('AllSpacesSold')} variant="info" />;
    }

    if (hasAllResourcesLimitReached && !isAllResourcesCategory) {
        return <Banner primaryText={lt('AllSpacesLimitReached')} variant="info" />;
    }

    if (hasRateGroupLimitReached) {
        return <RateGroupLimitReached {...other} />;
    }

    return <>{children}</>;
};
